import { useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface MarkStartOfPrototypeProps
  extends RouteComponentProps<{}, {}, { canGoBack?: boolean }> {}

const MarkStartOfPrototype: React.FC<MarkStartOfPrototypeProps> = props => {
  const { history, location } = props

  useEffect(
    () => {
      if (location.state && location.state.canGoBack === false) {
        return
      }

      history.replace({
        ...location,
        state: { ...location.state, canGoBack: false },
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return null
}

export default withRouter(MarkStartOfPrototype)
